<template>
  <el-tooltip
    effect="dark"
    :content="tooltipContent"
    placement="bottom"
    :disabled="!isEllipsis"
  >
    <div ref="textRef" class="ellipsis-tooltip" @mouseenter="handleMouseEnter">
      <slot />
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: "EllipsisTooltip",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isEllipsis: false,
      tooltipContent: ''
    };
  },
  watch: {
    content: {
      handler(val) {
        this.tooltipContent = val
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tooltipContent = this.content || this.getSlotText()
      this.checkEllipsis()
    });
    window.addEventListener("resize", this.checkEllipsis);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkEllipsis);
  },
  methods: {
    getSlotText() {
      if (this.$slots.default && this.$slots.default[0]) {
        return this.$slots.default[0].text || "";
      }
      return "";
    },
    checkEllipsis() {
      this.$nextTick(() => {
        const el = this.$refs.textRef
        if (el) {
          this.isEllipsis = el.scrollWidth > el.clientWidth
          if (!this.tooltipContent) {
            this.tooltipContent = el.textContent || ''
          }
        }
      })
    },
    handleMouseEnter() {
      this.$nextTick(() => {
        const el = this.$refs.textRef
        if (el) {
          this.tooltipContent = this.content || el.textContent || ''
          this.checkEllipsis()
        }
      })
    },
  },
};
</script>

<style>
.el-tooltip__popper {
  z-index: 10000 !important;
}
</style>

<style scoped>
.ellipsis-tooltip {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
